<div class="flex-grow-1 d-flex flex-column">
  <section class="bg-image-header">
    <div class="py-5 container-lg">
      <div class="text-center text-dark">
        <h1 class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mb-3 fade-in">
          <nz-logo mode="default" height="100"/>
          <span class="d-none d-md-block text-muted display-3">Collectoria</span>
          <span class="d-md-none display-2 text-muted">Collectoria</span>
        </h1>
        <p class="m-0 fw-normal fst-italic text-muted fade-in">
          Място, създадено от колекционери за колекционери – специализирано за колекционерски артикули.
        </p>
      </div>
      <div class="mt-5 container">
        <div class="row justify-content-center gap-3 gap-lg-5">
          <a class="shadow col-12 col-md-5 col-lg-3 btn btn-nz-primary"
             (click)="onOpenLoginModal()"
             [routerLink]="userLoggedIn ? appRoutes.adCrate : appRoutes.root">
            <i class="me-2 fa-solid fa-circle-plus" aria-hidden="true"></i>
            Добави нова обява
          </a>
          <a [routerLink]="appRoutes.adList"
             class="shadow col-12 col-md-5 col-lg-3 btn btn-nz-primary">
            <i class="me-2 fa-solid fa-list" aria-hidden="true"></i>
            Разгледай всички обяви
          </a>
        </div>
      </div>
    </div>
    <div class="bg-light bg-opacity-50">
      <div class="py-5 container-lg">
        <div class="text-center">
          <div class="row text-center justify-content-center">
            <div class="col-12 col-lg-8">
              <h2 class="text-muted">Какво търсите?</h2>
              <p class="fw-normal fst-italic text-muted">Въведете ключови думи, за да намерите това, което търсите.</p>
              <div class="input-group shadow rounded-3">
                <label for="search-input" class="visually-hidden">Търсене на колекционерски артикули</label>
                <input
                  type="search"
                  id="search-input"
                  [(ngModel)]="searchValue"
                  (keyup.enter)="searchButton.click()"
                  placeholder="Търсене на артикули..."
                  aria-label="Търсене на артикули"
                  aria-describedby="search-button"
                  class="form-control rounded-start-3">
                <a #searchButton
                   id="search-button"
                   [routerLink]="appRoutes.adList"
                   [queryParams]="{searchValue: searchValue}"
                   class="btn btn-dark"
                   aria-label="Търсене на артикули">
                  <i class="me-2 small fas fa-search" aria-hidden="true"></i>
                  <small class="d-none d-sm-inline">Търсене</small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-5 container-lg">
      <div class="text-center">
        <nz-categories-section [popularAdCategories]="popularAdCategories"/>
      </div>
    </div>
  </section>
  <section class="text-center bg-image flex-grow-1">
    <div class="container-lg">
      <div class="py-5">
        <h2 class="mb-5 text-muted">Популярни обяви</h2>
        <ul class="list-unstyled row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xl-4 justify-content-center g-4">
          @for (ad of popularAds; track ad.adId) {
            <li class="col">
              <nz-ad-card
                [data]="ad">
              </nz-ad-card>
            </li>
          }
        </ul>
      </div>
      <nz-events-section/>
    </div>
  </section>
</div>
